import React from "react";

const SAVING_BG_COLORS = {
  saving: "#c5d75d",
  done: "#c5d75d",
  disconnect: "#ff7600",
};

function SaveProgressBar({ saveStatus }) {
  // status: 'saving' | 'done' | 'disconnect' | null

  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    if (saveStatus === "saving") {
      setVisible(true);
    } else if (saveStatus === "done" || saveStatus === "disconnect") {
      const timeout = setTimeout(() => setVisible(false), 1000);
      return () => clearTimeout(timeout);
    } else {
      setVisible(false);
    }
  }, [saveStatus]);

  let progressValue = 0;
  let backgroundColor = "transparent";

  if (saveStatus === "done" || saveStatus === "disconnect") {
    progressValue = 100;
    backgroundColor = SAVING_BG_COLORS[saveStatus];
  } else if (saveStatus === "saving") {
    progressValue = 25;
    backgroundColor = SAVING_BG_COLORS[saveStatus];
  }

  return (
    visible && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          height: 4,
          width: "100%",
          backgroundColor: "#eee",
          zIndex: 30,
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${progressValue}%`,
            backgroundColor,
            transition: "width 0.5s ease, opacity 0.5s ease",
            opacity: visible ? 1 : 0,
          }}
        />
      </div>
    )
  );
}

export default SaveProgressBar;
